import { render, staticRenderFns } from "./DeviceDiagnosticsDetail.vue?vue&type=template&id=06373f0b&scoped=true"
import script from "./DeviceDiagnosticsDetail.vue?vue&type=script&lang=js"
export * from "./DeviceDiagnosticsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06373f0b",
  null
  
)

export default component.exports